/**
 * drawer.ts — мобильное бургер-меню (drawer)
 * Проект: TorgiRT (shared — все витрины)
 *
 * Перенос логики из zap.js (IIFE, строки 138-204) в ES-модуль.
 * Листовой модуль без импортов.
 */

let _closeDrawerImpl: (() => void) | null = null;

/** Close mobile drawer if initialized (DES-S-06 H4 — exported for search overlay). */
export function closeDrawer(): void {
  _closeDrawerImpl?.();
}

/**
 * Инициализация бургер-меню: открытие/закрытие drawer,
 * Escape, клик по overlay, автозакрытие на desktop.
 */
export function initDrawer(): void {
  const burgerBtn = document.getElementById('burger-btn');
  const drawer    = document.getElementById('mobile-drawer');
  const overlay   = document.getElementById('drawer-overlay');
  const closeBtn  = document.getElementById('drawer-close');

  if (!burgerBtn || !drawer || !overlay) return;

  const FOCUSABLE_SEL =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getDrawerFocusables(): HTMLElement[] {
    return Array.from(drawer!.querySelectorAll<HTMLElement>(FOCUSABLE_SEL)).filter(
      (el) => el.offsetParent !== null || el === document.activeElement
    );
  }

  function trapDrawerFocus(event: KeyboardEvent): void {
    if (!drawer!.classList.contains('is-open') || event.key !== 'Tab') return;
    const focusables = getDrawerFocusables();
    if (focusables.length === 0) {
      event.preventDefault();
      return;
    }
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement as HTMLElement | null;
    if (event.shiftKey) {
      if (!active || active === first || !drawer!.contains(active)) {
        event.preventDefault();
        last.focus();
      }
    } else if (!active || active === last || !drawer!.contains(active)) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeDrawerLocal(): void {
    document.removeEventListener('keydown', trapDrawerFocus, true);
    drawer!.classList.remove('is-open');
    overlay!.classList.remove('is-open');
    burgerBtn!.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    burgerBtn!.focus();
  }

  _closeDrawerImpl = closeDrawerLocal;

  function openDrawer(): void {
    const searchOverlay = document.getElementById('search-overlay');
    if (searchOverlay?.classList.contains('is-open')) {
      document.dispatchEvent(new CustomEvent('torgirt:close-search-overlay'));
    }
    drawer!.classList.add('is-open');
    overlay!.classList.add('is-open');
    burgerBtn!.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', trapDrawerFocus, true);
  }

  burgerBtn.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) { closeDrawerLocal(); } else { openDrawer(); }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawerLocal);
  }

  overlay.addEventListener('click', closeDrawerLocal);

  document.addEventListener('keydown', function (e: KeyboardEvent) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawerLocal();
    }
  });

  drawer.addEventListener('click', function (e: MouseEvent) {
    if ((e.target as Element).closest('.drawer-link')) {
      closeDrawerLocal();
    }
  });

  const desktopMQ = window.matchMedia('(min-width: 1024px)');
  function onDesktopChange(mq: MediaQueryListEvent | MediaQueryList): void {
    if (mq.matches && drawer!.classList.contains('is-open')) {
      closeDrawerLocal();
    }
  }
  if (desktopMQ.addEventListener) {
    desktopMQ.addEventListener('change', onDesktopChange);
  }
}
